import { Button, Stack, Typography, useTheme } from "@mui/material";
import dayjs from "dayjs";
import ClearIcon from "@mui/icons-material/Clear";
import CheckIcon from "@mui/icons-material/Check";
import { tokens } from "../../../../../../../locales/tokens";
import { useTranslation } from "react-i18next";

export type AnswerCardProps = {
  handleSetResult: (id: number, questionId: number, value: boolean) => void;
  title: string;
  id: number;
  UserQuestionAnswer: {
    userQuestionId: number;
    answerId: number;
    text: string;
    isCorrect: boolean | null;
    createdAt: string;
  };
};

export const AnswerCard = ({
  id,
  UserQuestionAnswer,
  handleSetResult,
}: AnswerCardProps) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const handleButtonClick = (value: boolean) => {
    if (value !== UserQuestionAnswer.isCorrect)
      handleSetResult(id, UserQuestionAnswer.userQuestionId, value);
  };

  const backgroundColor =
    UserQuestionAnswer.isCorrect === true
      ? theme.palette.mode === "dark"
        ? "#1d3524"
        : "#e6f4ea"
      : UserQuestionAnswer.isCorrect === false
      ? theme.palette.mode === "dark"
        ? "#3b1e1e"
        : "#fbeaea"
      : "transparent";
  const dateColor =
    theme.palette.mode === "dark" ? theme.palette.text.secondary : "#666666";

  return (
    <Stack
      py={1}
      px={2}
      sx={{
        borderBottom: `1px solid ${theme.palette.divider}`,
        backgroundColor,
        "&:last-of-type": {
          borderBottom: "none",
        },
        transition: "background-color 0.3s ease",
      }}
      spacing={1}
    >
      <Stack
        display="flex"
        alignItems="center"
        flexDirection="row"
        flexWrap="wrap"
        gap={4}
      >
        <Typography flexGrow={1} color={dateColor} variant="body2">
          {dayjs(UserQuestionAnswer.createdAt).format("DD.MM.YYYY HH:mm")}
        </Typography>

        <Button
          onClick={() => handleButtonClick(true)}
          startIcon={<CheckIcon />}
          color="success"
          variant="text"
          size="small"
          sx={{
            textTransform: "none",
          }}
        >
          {t(tokens.test.markAsCorrect)}
        </Button>
        <Button
          onClick={() => handleButtonClick(false)}
          startIcon={<ClearIcon />}
          color="error"
          variant="text"
          size="small"
          sx={{
            textTransform: "none",
          }}
        >
          {t(tokens.test.markAsWrong)}
        </Button>
      </Stack>
      <Typography variant="body2">{UserQuestionAnswer.text}</Typography>
    </Stack>
  );
};
